import React from 'react';
import { Box } from '@mui/material';
import FieldHelpIcon from './FieldHelpIcon';
import { FIELD_HELP } from './fieldHelpContent';

interface LabelWithHelpProps {
  text: string;
  helpKey: string;
}

/** Field label with an inline "?" help icon when help content exists. */
export const LabelWithHelp: React.FC<LabelWithHelpProps> = ({ text, helpKey }) => {
  const help = FIELD_HELP[helpKey];
  if (!help) return <>{text}</>;

  return (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.25 }}>
      <span>{text}</span>
      <FieldHelpIcon title={help.description} example={help.example} tip={help.tip} />
    </Box>
  );
};

export default LabelWithHelp;
